import { render } from "./InputTextarea.vue?vue&type=template&id=2a2594ad&scoped=true"
import script from "./InputTextarea.vue?vue&type=script&lang=js"
export * from "./InputTextarea.vue?vue&type=script&lang=js"

import "./InputTextarea.vue?vue&type=style&index=0&id=2a2594ad&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a2594ad"

export default script